import { Depot } from "./Depot";
import { Place } from "./Place";
import { RouteSegment } from "./RouteSegment";
import { Currency } from "./Currency";
import { Unit } from "./Unit";
import { PackingType } from "./PackingType";
import { ExpeditionOptions } from "./ExpeditionOptions";

// Modelo principal (con entidades)
export interface WarehouseOrderExpedition {
    id?: number;
    warehouse_order_id?: number;

    depot?: Depot;
    depot_id?: number;

    place?: Place;
    place_id?: number;

    origin?: string;
    origin_id?: number;


    destiny?: string;
    destiny_id?: number;
    route_segment?: RouteSegment;
    route_segment_id?: number;

    packing_type?: PackingType;
    rate?: number;

    currency?: Currency;
    currency_id?: number;

    unit?: Unit;
    unit_id?: number;

    created_at?: string;
    updated_at?: string;
}

// Modelo para uso en formularios
export interface WarehouseOrderExpeditionDataForm {
    id?: number;
    warehouse_order_id?: number;

    depot?: Depot;
    depot_id?: number;

    place?: Place;
    place_id?: number;

    origin?: string;
    origin_id?: number;
    destiny?: string;
    destiny_id?: number;
    route_segment?: RouteSegment;
    expeditions_options?: ExpeditionOptions;
    route_segment_id?: number | null;
    expeditions_option_id?: number | null;

    container_type?: string;
    rate?: number;

    currency?: Currency;
    currency_id?: number;

    unit?: Unit;
    unit_id?: number;

    packing_type?: PackingType;
    packing_type_id?: number;

    created_at?: string;
    updated_at?: string;
}
export interface WarehouseOrderExpeditionShowDataForm {
    id?: number;
    warehouse_order_id?: number;

    depot?: string;
    depot_id?: number;

    place?: Place;
    place_id?: number;

    origin?: string;
    origin_id?: number;
    destiny?: string;
    destiny_id?: number;
    route_segment?: RouteSegment;
    expedition_options?: ExpeditionOptionsDataForm
    route_segment_id?: number;

    container_type?: string;
    rate?: number;

    currency?: string;
    currency_id?: number;

    unit?: string;
    unit_id?: number;

    packing_type?: string;
    packing_type_id?: number;

    created_at?: string;
    updated_at?: string;
}

export const defaultWarehouseOrderExpeditionDataForm: WarehouseOrderExpeditionDataForm = {
    id: undefined,
    depot_id: undefined,
    place_id: undefined,
    route_segment_id: undefined,
    container_type: '',
    rate: 0,
    currency_id: undefined,
    unit_id: undefined
};

// Filtros para paginación/tablas
export interface WarehouseOrderExpeditionFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
}


export interface ExpeditionOptionsDataForm {
    id?: number;
    expedition_options?: string;
    origin?: string;
    origin_id?: number;
    destiny?: string;
    destiny_id?: number;
    packing_type?: string;
    packing_type_id?: number;
}

